import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: '',
    header: 'mb-8 flex justify-between max-sm:flex-col max-sm:gap-3',
    title: 'heading-3xl max-sm:heading-2xl',
    button: 'px-1! max-sm:self-start',
    carousel:
      '[--slide-size:340px] [--slide-spacing:20px] max-sm:[--slide-spacing:16px] sm:[--slide-size:calc(100%/2)] lg:[--slide-size:calc(100%/3)]',
    viewport: 'max-sm:-mx-3 max-sm:w-[calc(100%+24px)] max-sm:px-3',
    arrowPrev: 'top-[160px] -left-4 2xl:-left-6',
    arrowNext: 'top-[160px] -right-4 2xl:-right-6',
    icon: 'ml-3'
  }
});
